module.exports = __webpack_public_path__ + "img/la.21ed06fe.png";